const userParams = [
    {
        path: 'userRegistrationCountry',
        key: 'userRegistrationCountry',
    },
    {
        path: 'userStatus.description',
        key: 'userState',
    },
    {
        path: 'cbsPackageInfo[0]packageCode',
        key: 'packageCode',
    },
    {
        path: 'activeProfile.profileType',
        key: 'userProfileType',
    },
    {
        path: 'cbsPackageInfo[0]packageSource',
        key: 'billingVendor',
    },
];

export { userParams };
